import { replaceContentFontIcons } from '../../utils/content-icon-html';
// Raw CMS rendering only rewrites images; it must not pull the HTML parser into
// every header/footer that imports this component. The legacy re-export stays
// available on html-renderer for existing consumer imports.
import { rewriteHtmlImageSources } from '@eliadmin/core/src/utils/html-image-sources';
import type { HtmlImagePolicy } from '@eliadmin/core/src/utils/html-image-sources';
import { forwardRef } from 'react';
import type { CSSProperties, ElementType, HTMLAttributes } from 'react';

type HtmlRendererRawProps = HTMLAttributes<HTMLElement> & {
  html?: unknown;
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
  imagePolicy?: HtmlImagePolicy;
};

export const HtmlRendererRaw = forwardRef<HTMLElement, HtmlRendererRawProps>(
  function HtmlRendererRaw(props, ref) {
    const {
      as: Component = 'div',
      html: rawHtml,
      className,
      style,
      imagePolicy,
      ...restProps
    } = props;
    const html = typeof rawHtml === 'string' ? rawHtml : '';

    if (!html) {
      return <Component ref={ref} className={className} style={style} {...restProps} />;
    }

    return (
      <Component
        ref={ref}
        className={className}
        style={style}
        dangerouslySetInnerHTML={{ __html: rewriteHtmlImageSources(replaceContentFontIcons(html), imagePolicy) }}
        {...restProps}
      />
    );
  },
);
